/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMinRightIcon20Regular = forwardRef('ArrowDim2DiagMinRightIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M18.03 3.03a.75.75 0 0 0-1.06-1.06l-5.22 5.22V3.75a.75.75 0 0 0-1.5 0V8c0 .966.784 1.75 1.75 1.75h4.25a.75.75 0 0 0 0-1.5h-3.44l5.22-5.22Z" }),
        React.createElement("path", { d: "M8.25 16.25v-3.44l-5.22 5.22a.75.75 0 0 1-1.06-1.06l5.22-5.22H3.75a.75.75 0 0 1 0-1.5H8c.966 0 1.75.784 1.75 1.75v4.25a.75.75 0 0 1-1.5 0Z" })));
});
